import React, { useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ControlButtons from "../ControlButtons/ControlButtons.jsx";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import LoadingPaper from "../LoadingPaper/LoadingPaper.jsx";
import PropertiesList from "../PropertiesList/PropertiesList.jsx";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RelationsList from "../RelationsList/RelationsList.jsx";

import {
    editButtonTheme as back,
    toggleButtonTheme as submit,
} from "../../config/theme";

const AddForm = (props) => {
    const MUTABLE = true;
    useEffect(() => {
        props.initAction()
        if (props?.getPlacesSale) {
            props.getPlacesSale()
        }
    }, []);
    const {
        fields,
        item,
        fieldUpdateHandler,
        errorFields,
        relations,
        relationsDataSource,
        setRelationsValue,
        defaultPaymentTypes,
        defaultServices,
        serviceCategories,
        defaultValues,
        updateImage,
        defaultRoomFeatures,
        defaultRoomTypes,
        loadedRoomFeatures,
        unusedServicesHidden,
        defaultRates,
        cancellationPolicy,
        defaultHotels,
        placesSale,
        interfaceTypes,
        imageAcceptExtensions,
        defaultDiscountTypes
    } = { ...props };
    const buttons = item
        ? [
              {
                  type: back,
                  icon: <ArrowBackIcon />,
                  caption: "Вернуться",
                  link: props.getBackLink(),
              },
              {
                  type: submit,
                  icon: <SaveIcon />,
                  caption: "Сохранить",
                  action: props.submitAction,
              },
          ]
        : null;

    delete fields.api_token;

    return !item || props.loading ? (
        <Paper elevation={3}>
            <LoadingPaper />
        </Paper>
    ) : (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {props.title}
                </Typography>
            </Box>
            <Box mt={4}>
                <PropertiesList
                    fields={fields}
                    mutable={MUTABLE}
                    item={item}
                    ignoreEditable={true}
                    fieldUpdateHandler={fieldUpdateHandler}
                    errorFields={errorFields}
                    relationsDataSource={relationsDataSource}
                    defaultPaymentTypes={defaultPaymentTypes}
                    defaultServices={defaultServices}
                    serviceCategories={serviceCategories}
                    defaultValues={defaultValues}
                    updateImage={updateImage}
                    imageAcceptExtensions={imageAcceptExtensions}
                    defaultRoomFeatures={defaultRoomFeatures}
                    defaultRoomTypes={defaultRoomTypes}
                    defaultRates={defaultRates}
                    cancellationPolicy={cancellationPolicy}
                    defaultHotels={defaultHotels}
                    placesSale={placesSale}
                    interfaceTypes={interfaceTypes}
                    defaultDiscountTypes={defaultDiscountTypes}
                    loadedRoomFeatures={loadedRoomFeatures}
                    unusedServicesHidden={unusedServicesHidden}
                />
            </Box>
            {relations && (
                <RelationsList
                    relations={relations}
                    relationsDataSource={relationsDataSource}
                    setRelationsValue={setRelationsValue}
                />
            )}
            <Box pt={4} pb={4}>
                {<ControlButtons items={buttons} />}
            </Box>
        </Paper>
    );
};

AddForm.defaultProps = {
    loading: true,
};

AddForm.propTypes = {
    title: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    fields: PropTypes.object,
    item: PropTypes.object,
    initAction: PropTypes.func.isRequired,
    submitAction: PropTypes.func.isRequired,
    fieldUpdateHandler: PropTypes.func.isRequired,
    getBackLink: PropTypes.func.isRequired,
    errorFields: PropTypes.object,
    relations: PropTypes.object,
    relationsDataSource: PropTypes.func,
    setRelationsValue: PropTypes.func,
    getDefaultValues: PropTypes.func,
    defaultPaymentTypes: PropTypes.array,
    defaultServices: PropTypes.array,
    defaultValues: PropTypes.array,
    loadedPaymentTypes: PropTypes.bool,
    loadedServices: PropTypes.bool,
};

export default AddForm;
